export const FETCH_REG_REQUEST = "FETCH_REG_REQUEST"
export const FETCH_REG_SUCCESS = 'FETCH_REG_SUCCESS'
export const FETCH_REG_FAILURE = 'FETCH_REG_FAILURE'
export const HANDLE_LOGIN = "HANDLE_LOGIN"
export const HANDLE_LOGOUT = "HANDLE_LOGOUT"
export const HANDLE_REGISTRATION = "HANDLE_REGISTRATION"
export const ADD_TO_CART = "ADD_TO_CART"
export const ADD_PRODUCT = "ADD_PRODUCT"
export const REMOVE_PRODUCT = "REMOVE_PRODUCT"
export const DECREASE_ITEMS = "DECREASE_ITEMS"
export const ORDER_PLACED ="ORDER_PLACED"
export const CHECKOUT = "CHECKOUT"
export const GO_TO_CART = "GO_TO_CART"
export const ORDER_CONFIRMED = 'ORDER_CONFIRMED'